import React from 'react';
import Header from '../components/Header/Header';
import PriceHero from '../components/PriceHero/PriceHero';
import PriceTicker from '../components/PriceTicker/PriceTicker';
import Footer from '../components/Footer/Footer';
import Markets from '../components/Markets/Markets';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import Methodology from '../components/Methodology/Methodology';
import DataPower from '../components/DataPower/DataPower';
import PriceBenefits from '../components/PriceBenefits/PriceBenefits';
import Analysts from '../components/Analysts/Analysts'; 
import Trust from '../components/Trust/Trust';

const PricesPage = () => {
  return (
    <>
      <Header />
      <main>
        <PriceHero />
        <PriceTicker />
        <Markets />
        <Methodology />
        <PriceBenefits />
        <Analysts />
        <Trust />
        {/* You can add more sections specific to the prices page here later */}
        <DataPower />
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default PricesPage;